var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgY({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.39 23.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.12,0c.32,0,.54.26.64.54l3.46,9.02c.16.42.26.48.48.48s.32-.06.48-.48L13.63.54c.1-.29.32-.54.64-.54h4.61c.32,0,.51.22.51.48,0,.06,0,.16-.03.22l-4.83,11.07c-.64,1.47-1.31,2.14-2.08,2.46v8.9c0,.35-.29.64-.64.64h-4.19c-.35,0-.64-.29-.64-.64v-8.9c-.77-.32-1.47-.99-2.11-2.46L.03.7c-.03-.06-.03-.16-.03-.22,0-.26.19-.48.51-.48h4.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgY);
export default __webpack_public_path__ + "static/media/Y.05d15964f0d3f8a62551d0c688cbcf0d.svg";
export { ForwardRef as ReactComponent };